// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
//     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

//     this.debouncedOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 800);

//     const facetForm = this.querySelector('form');
//     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

//     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
//     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
//   }

//   static setListeners() {
//     const onHistoryChange = (event) => {
//       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
//       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
//       FacetFiltersForm.renderPage(searchParams, null, false);
//     };
//     window.addEventListener('popstate', onHistoryChange);
//   }

//   static toggleActiveFacets(disable = true) {
//     document.querySelectorAll('.js-facet-remove').forEach((element) => {
//       element.classList.toggle('disabled', disable);
//     });
//   }

//   static renderPage(searchParams, event, updateURLHash = true) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     const countContainer = document.getElementById('ProductCount');
//     const countContainerDesktop = document.getElementById('ProductCountDesktop');
//     const loadingSpinners = document.querySelectorAll(
//       '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
//     );
//     loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
//     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
//     if (countContainer) {
//       countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop) {
//       countContainerDesktop.classList.add('loading');
//     }

//     sections.forEach((section) => {
//       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
//       const filterDataUrl = (element) => element.url === url;

//       FacetFiltersForm.filterData.some(filterDataUrl)
//         ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
//         : FacetFiltersForm.renderSectionFromFetch(url, event);
//     });

//     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
//   }

//   static renderSectionFromFetch(url, event) {
//     fetch(url)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const html = responseText;
//         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
//         FacetFiltersForm.renderFilters(html, event);
//         FacetFiltersForm.renderProductGridContainer(html);
//         FacetFiltersForm.renderProductCount(html);
//         if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
//         let loadMoreButtons = document.querySelectorAll(".js-load-more");
//         loadMoreButtons.forEach((loadMoreButton) => {
//             console.log(loadMoreButton);
//             loadMoreButton.addEventListener("click", window._handleLoadMoreClick.bind(this), true);
//         });
//         let newQuickViewaBtns = document.querySelectorAll(".js-pro-cart-button");
//         newQuickViewaBtns.forEach((newQuickViewaBtn) => {
//           newQuickViewaBtn.addEventListener("click",(e)=>{
//             let quickViewDiv = e.target.closest(".card--standard").querySelector(".quick-add").querySelector(".quick-add__submit");
//             console.log(quickViewDiv)
//             quickViewDiv.click();
//           })
//         })
 
       
//       });
//     // setTimeout(function(){
//     //   window.sampleCollectionBundle.init();
//     // },2500);
//   }

//   static renderSectionFromCache(filterDataUrl, event) {
//     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
//     FacetFiltersForm.renderFilters(html, event);
//     FacetFiltersForm.renderProductGridContainer(html);
//     FacetFiltersForm.renderProductCount(html);
//     if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
//   }

//   static renderProductGridContainer(html) {
//     document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
//       .parseFromString(html, 'text/html')
//       .getElementById('ProductGridContainer').innerHTML;

//     document
//       .getElementById('ProductGridContainer')
//       .querySelectorAll('.scroll-trigger')
//       .forEach((element) => {
//         element.classList.add('scroll-trigger--cancel');
//       });
//   }

//   static renderProductCount(html) {
//     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;

//     const container = document.getElementById('ProductCount');
//     const containerDesktop = document.getElementById('ProductCountDesktop');
//     container.innerHTML = count;
//     container.classList.remove('loading');
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove('loading');
//     }
//     const loadingSpinners = document.querySelectorAll(
//       '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
//     );
//     loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
        
//   }

//   static renderFilters(html, event) {
    
//     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
//     const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
//       '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
//     );
//     const facetDetailsElementsFromDom = document.querySelectorAll(
//       '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
//     );
    
//     // Remove facets that are no longer returned from the server
//     Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
//       if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
//         currentElement.remove();
//       }
//     });

//     const matchesId = (element) => {
//       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
//       return jsFilter ? element.id === jsFilter.id : false;
//     };

//     const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
//     const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

//     facetsToRender.forEach((elementToRender, index) => {
//       const currentElement = document.getElementById(elementToRender.id);
//       // Element already rendered in the DOM so just update the innerHTML
//       if (currentElement) {
//         document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
//       } else {
//         if (index > 0) {
//           const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
//           // Same facet type (eg horizontal/vertical or drawer/mobile)
//           if (elementToRender.className === previousElementClassName) {
//             document.getElementById(previousElementId).after(elementToRender);
//             return;
//           }
//         }

//         if (elementToRender.parentElement) {
//           document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
//         }
//       }
//     });

//     FacetFiltersForm.renderActiveFacets(parsedHTML);
//     FacetFiltersForm.renderAdditionalElements(parsedHTML);

//     if (countsToRender) {
//       const closestJSFilterID = event.target.closest('.js-filter').id;

//       if (closestJSFilterID) {
//         FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
//         FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

//         const newFacetDetailsElement = document.getElementById(closestJSFilterID);
//         const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
//           ? `.mobile-facets__close-button`
//           : `.facets__summary`;
//         const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

//         const isTextInput = event.target.getAttribute('type') === 'text';

//         if (newElementToActivate && !isTextInput) newElementToActivate.focus();
//       }
//     }

//   }

//   static renderActiveFacets(html) {
//     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

//     activeFacetElementSelectors.forEach((selector) => {
//       const activeFacetsElement = html.querySelector(selector);
//       if (!activeFacetsElement) return;
//       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
//     });

//     FacetFiltersForm.toggleActiveFacets(false);
//   }

//   static renderAdditionalElements(html) {
//     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

//     mobileElementSelectors.forEach((selector) => {
//       if (!html.querySelector(selector)) return;
//       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
//     });

//     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
//      setTimeout(()=>{

//       let filterElms = document.querySelectorAll(".js-filter-tab");
//       let filterSizeElems = document.querySelectorAll(".js-filter-size-tab");
//       filterElms.forEach((filterElm) => {
//         filterElm.addEventListener("change" , (event) =>{
//           console.log(event)
//            filterElms.forEach((filterElm) => {
//              if(filterElm.querySelector("input").hasAttribute("checked")  === false){

//                filterElm.classList.remove("active");
//              }
//            })
//           event.currentTarget.querySelector("input").setAttribute("checked","");
//           if(event.currentTarget.classList.contains("active") === false && filterElm.querySelector("input").hasAttribute("checked") === true){
  
//             event.currentTarget.classList.add("active");
//           }
//         })
//       })
//       filterSizeElems.forEach((filterSizeElem) => {
//         filterSizeElem.addEventListener("change" , (event) =>{
//           console.log(event)
//            filterSizeElems.forEach((filterSizeElem) => {
//              filterSizeElem.classList.remove("active");
//              filterSizeElem.querySelector("input").removeAttribute("checked");
            
//            })
//           if(event.currentTarget.classList.contains("active") === false){ 
//            event.currentTarget.querySelector("input").setAttribute("checked","");
//             event.currentTarget.classList.add("active");
//           }
//         })
//       })
       
//     },700)
//   }

//   static renderCounts(source, target) {
//     const targetSummary = target.querySelector('.facets__summary');
//     const sourceSummary = source.querySelector('.facets__summary');

//     if (sourceSummary && targetSummary) {
//       targetSummary.outerHTML = sourceSummary.outerHTML;
//     }

//     const targetHeaderElement = target.querySelector('.facets__header');
//     const sourceHeaderElement = source.querySelector('.facets__header');

//     if (sourceHeaderElement && targetHeaderElement) {
//       targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
//     }

//     const targetWrapElement = target.querySelector('.facets-wrap');
//     const sourceWrapElement = source.querySelector('.facets-wrap');

//     if (sourceWrapElement && targetWrapElement) {
//       const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
//       if (isShowingMore) {
//         sourceWrapElement
//           .querySelectorAll('.facets__item.hidden')
//           .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
//       }

//       targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
//       setTimeout(function(){
//         const filterCount = target.querySelector(".facets_summary").querySelector(".facets__header").querySelector(".facets__selecteds");
//         console.log(filterCount);
//         document.querySelectorAll(".js-selected-filter-count").forEach((sl)=>{
//           if(target.classList.contains("js-scent-result") == true){
//             if(sl.classList.contains("js-scent-count") == true){
//               sl.innerText = filterCount.innerText;
//             } 
//           }
//           else{
//               if(sl.classList.contains("js-size-count") == true){ 
//                  sl.innerText = filterCount.innerText;
//               }
//             }
//         })
//       window.sampleCollectionBundle.init();
//      },500);
//     }
//   }

//   static renderMobileCounts(source, target) {
//     const targetFacetsList = target.querySelector('.mobile-facets__list');
//     const sourceFacetsList = source.querySelector('.mobile-facets__list');

//     if (sourceFacetsList && targetFacetsList) {
//       targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
//     }
//   }

//   static updateURLHash(searchParams) {
//     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
//   }

//   static getSections() {
//     return [
//       {
//         section: document.getElementById('product-grid').dataset.id,
//       },
//     ];
//   }

//   createSearchParams(form) {
//     const formData = new FormData(form);
//     return new URLSearchParams(formData).toString();
//   }

//   onSubmitForm(searchParams, event) {
//     FacetFiltersForm.renderPage(searchParams, event);
//     document.querySelector("body").classList.add("filter_active");
   
//     // document.querySelectorAll(".js-selected-filter-count").forEach((co) => co.classList.remove("hidden"));
//   }

//   onSubmitHandler(event) {
//     event.preventDefault();
//     if(event.target.closest("ul").classList.contains("js-scent-result")){
//         document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
//           if(co.classList.contains("js-scent-count") == true){
//              co.classList.remove("hidden")
//           }
       
//        });
//       }if(event.target.closest("ul").classList.contains("js-size-result")){
//          document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
//           if(co.classList.contains("js-size-count") == true){
//              co.classList.remove("hidden")
//           }
       
//        });
//       }
//     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
//         console.log(event.target.getAttribute("data-label-value"))
//     if(event.target.getAttribute("data-label-value") != null){
//       document.querySelector(".js-show-sort").querySelector("span").innerText = `${event.target.getAttribute("data-label-value")} `
//     }
//     if (event.srcElement.className == 'mobile-facets__checkbox') {
//       const searchParams = this.createSearchParams(event.target.closest('form'));
//       this.onSubmitForm(searchParams, event);
//     } else {
//       const forms = [];
//       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
//       sortFilterForms.forEach((form) => {
//         if (!isMobile) {
//           console.log(form.id);
//           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
//             forms.push(`${this.createSearchParams(form)}&filter.v.availability=1`);
//           }
//         } else if (form.id === 'FacetFiltersFormMobile') {
//           forms.push(`${this.createSearchParams(form)}&filter.v.availability=1`);
//         }
       
//       });
//       this.onSubmitForm(forms.join('&'), event);
//     }
//   }

//   onActiveFilterClick(event) {
//     console.log(event)
//     event.preventDefault();
//     FacetFiltersForm.toggleActiveFacets();
//     const url =
//       event.currentTarget.href.indexOf('?') == -1
//         ? ''
//         : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
//     FacetFiltersForm.renderPage(url);
//     if(event.currentTarget.href.indexOf('?') != -1){
//       FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
//     }
//     if(event.currentTarget.href.split("?")[1] && event.currentTarget.href.split("?")[1].includes("filter.p.m.custom.scent_type_filter") == false){
//        document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
//           if(co.classList.contains("js-scent-count") == true){
//              co.classList.add("hidden")
//           }
//        });
//     } 
//     if(event.currentTarget.href.split("?")[1] && event.currentTarget.href.split("?")[1].includes("filter.p.m.custom.size_filter") == false){
//        document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
//           if(co.classList.contains("js-size-count") == true){
//              co.classList.add("hidden")
//           }
//        });
//     } 
//     event.currentTarget.href.indexOf('?') == -1 ? document.querySelectorAll(".js-selected-filter-count").forEach((co)=>co.classList.add("hidden")): document.querySelectorAll(".js-selected-filter-count").forEach((co)=>co.classList.remove("hidden"));
//     event.currentTarget.href.indexOf('?') == -1 ?  document.querySelector(".js-show-sort").querySelector("span").innerText = "Sort" : "";
//     event.currentTarget.href.indexOf('?') == -1 ? document.querySelector("body").classList.remove("filter_active") : document.querySelector("body").classList.add("filter_active");
//   }
// }

// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// customElements.define('facet-filters-form', FacetFiltersForm);
// FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input').forEach((element) => {
//       element.addEventListener('change', this.onRangeChange.bind(this));
//       element.addEventListener('keydown', this.onKeyDown.bind(this));
//     });
//     this.setMinAndMaxValues();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   onKeyDown(event) {
//     if (event.metaKey) return;

//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('data-min'));
//     const max = Number(input.getAttribute('data-max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

// customElements.define('price-range', PriceRange);

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define('facet-remove', FacetRemove);



class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // New method to toggle active_filter class on #product-grid
  // New method to toggle active_filter class on #product-grid
  static toggleProductGridActiveFilter(hasFilters) {
    const productGrid = document.getElementById('product-grid');
     const activeFilterButtons = document.querySelector('.active-facets-desktop').querySelectorAll("facet-remove");
    if (productGrid && activeFilterButtons.length > 1) {
      if (hasFilters) {
        productGrid.classList.add('active_filter');
      } else {
        productGrid.classList.remove('active_filter');
      }
    }
  }

  // New method to check if filters are active (excluding sort_by)
  static hasActiveFilters() {
    const searchParams = window.location.search;
    // Check if there are any filter parameters (excluding section_id and sort_by)
    if (!searchParams || searchParams === '') return false;
    
    const params = new URLSearchParams(searchParams);
    // Remove section_id and sort_by to check for actual filters only
    params.delete('section_id');
    params.delete('sort_by');
    
    // Also check by counting facet-remove elements (more accurate for rendered state)
    const facetRemoveElements = document.querySelectorAll('facet-remove');
    // If there's more than 1 facet-remove (excluding the "Clear all" button), filters are active
    return facetRemoveElements.length > 1 || params.toString().length > 0;
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
    // Toggle active_filter class based on whether filters are active
    FacetFiltersForm.toggleProductGridActiveFilter(searchParams && searchParams.length > 0);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        let loadMoreButtons = document.querySelectorAll(".js-load-more");
        loadMoreButtons.forEach((loadMoreButton) => {
            console.log(loadMoreButton);
            loadMoreButton.addEventListener("click", window._handleLoadMoreClick.bind(this), true);
        });
        let newQuickViewaBtns = document.querySelectorAll(".js-pro-cart-button");
        newQuickViewaBtns.forEach((newQuickViewaBtn) => {
          newQuickViewaBtn.addEventListener("click",(e)=>{
            let quickViewDiv = e.target.closest(".card--standard").querySelector(".quick-add").querySelector(".quick-add__submit");
            console.log(quickViewDiv)
            quickViewDiv.click();
          })
        })
 
       
      });
    // setTimeout(function(){
    //   window.sampleCollectionBundle.init();
    // },2500);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const productGrid = document.getElementById('product-grid');
    
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    
    // Check and apply/remove active_filter class after HTML render
    const updatedProductGrid = document.getElementById('product-grid');
    if (updatedProductGrid) {
      // Wait a bit for facet-remove elements to be rendered
      setTimeout(() => {
        if (FacetFiltersForm.hasActiveFilters()) {
          updatedProductGrid.classList.add('active_filter');
        } else {
          updatedProductGrid.classList.remove('active_filter');
        }
      }, 100);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;

    const container = document.getElementById('ProductCount');
    const countElm = document.querySelector(".js-pro-count-elm");
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    countElm.innerHTML = `${count} product results`;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
        
  }

  static renderFilters(html, event) {
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    
    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    
    // Check if any filters are actually active after rendering
    // Count facet-remove elements excluding the "Clear all" button wrapper
    const activeFilterButtons = document.querySelector('.active-facets-desktop').querySelectorAll("facet-remove");
    const productGrid = document.getElementById('product-grid');
    console.log(activeFilterButtons,"djdjfgjh")
    if (productGrid) {
      if (activeFilterButtons.length > 1) {
        productGrid.classList.add('active_filter');
      } else {
        productGrid.classList.remove('active_filter');
      }
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
     setTimeout(()=>{

      let filterElms = document.querySelectorAll(".js-filter-tab");
      let filterSizeElems = document.querySelectorAll(".js-filter-size-tab");
      filterElms.forEach((filterElm) => {
        filterElm.addEventListener("change" , (event) =>{
          console.log(event)
           filterElms.forEach((filterElm) => {
             if(filterElm.querySelector("input").hasAttribute("checked")  === false){

               filterElm.classList.remove("active");
             }
           })
          event.currentTarget.querySelector("input").setAttribute("checked","");
          if(event.currentTarget.classList.contains("active") === false && filterElm.querySelector("input").hasAttribute("checked") === true){
  
            event.currentTarget.classList.add("active");
          }
        })
      })
      filterSizeElems.forEach((filterSizeElem) => {
        filterSizeElem.addEventListener("change" , (event) =>{
          console.log(event)
           filterSizeElems.forEach((filterSizeElem) => {
             filterSizeElem.classList.remove("active");
             filterSizeElem.querySelector("input").removeAttribute("checked");
            
           })
          if(event.currentTarget.classList.contains("active") === false){ 
           event.currentTarget.querySelector("input").setAttribute("checked","");
            event.currentTarget.classList.add("active");
          }
        })
      })
       
    },700)
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
      setTimeout(function(){
        const filterCount = target.querySelector(".facets_summary").querySelector(".facets__header").querySelector(".facets__selecteds");
        console.log(filterCount);
        document.querySelectorAll(".js-selected-filter-count").forEach((sl)=>{
          if(target.classList.contains("js-scent-result") == true){
            if(sl.classList.contains("js-scent-count") == true){
              sl.innerText = filterCount.innerText;
            } 
          }
          else{
              if(sl.classList.contains("js-size-count") == true){ 
                 sl.innerText = filterCount.innerText;
              }
            }
        })
      window.sampleCollectionBundle.init();
     },500);
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    
    // Check if filters are actually active
    if (searchParams && searchParams.length > 0) {
      document.querySelector("body").classList.add("filter_active");
      
      // Wait for render to complete, then check if filters are active
      setTimeout(() => {
        console.log("jhbghvdfbjhgbdfjh",FacetFiltersForm.hasActiveFilters())
        const productGrid = document.getElementById('product-grid');
        const activeFilterButtons = document.querySelector('.active-facets-desktop').querySelectorAll("facet-remove");
        if (productGrid && FacetFiltersForm.hasActiveFilters() && activeFilterButtons.length > 1) {
          productGrid.classList.add('active_filter');
        } else if (productGrid) {
          productGrid.classList.remove('active_filter');
        }
      }, 200);
    } else {
      document.querySelector("body").classList.remove("filter_active");
      const productGrid = document.getElementById('product-grid');
      if (productGrid) {
        productGrid.classList.remove('active_filter');
      }
    }
   
    // document.querySelectorAll(".js-selected-filter-count").forEach((co) => co.classList.remove("hidden"));
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if(event.target.closest("ul").classList.contains("js-scent-result")){
        document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
          if(co.classList.contains("js-scent-count") == true){
             co.classList.remove("hidden")
          }
       
       });
      }if(event.target.closest("ul").classList.contains("js-size-result")){
         document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
          if(co.classList.contains("js-size-count") == true){
             co.classList.remove("hidden")
          }
       
       });
      }
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        console.log(event.target.getAttribute("data-label-value"))
    if(event.target.getAttribute("data-label-value") != null){
      document.querySelector(".js-show-sort").querySelector("span").innerText = `${event.target.getAttribute("data-label-value")} `
    }
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          console.log(form.id);
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(`${this.createSearchParams(form)}&filter.v.availability=1`);
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(`${this.createSearchParams(form)}&filter.v.availability=1`);
        }
       
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    console.log(event)
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    if(event.currentTarget.href.indexOf('?') != -1){
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }
    if(event.currentTarget.href.split("?")[1] && event.currentTarget.href.split("?")[1].includes("filter.p.m.custom.scent_type_filter") == false){
       document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
          if(co.classList.contains("js-scent-count") == true){
             co.classList.add("hidden")
          }
       });
    } 
    if(event.currentTarget.href.split("?")[1] && event.currentTarget.href.split("?")[1].includes("filter.p.m.custom.size_filter") == false){
       document.querySelectorAll(".js-selected-filter-count").forEach((co)=>{
          if(co.classList.contains("js-size-count") == true){
             co.classList.add("hidden")
          }
       });
    }
    
    // Handle active_filter class when removing filters
    const productGrid = document.getElementById('product-grid');
    const activeFilterButtons = document.querySelector('.active-facets-desktop').querySelectorAll("facet-remove");
    
    if (productGrid) {
      if (event.currentTarget.href.indexOf('?') != -1 && event.currentTarget.href.indexOf('&') != -1 && activeFilterButtons.length > 1) {
        // All filters removed
        productGrid.classList.add('active_filter');
      } else {
        productGrid.classList.remove('active_filter');
        // Some filters still active
      }
    }
    
    event.currentTarget.href.indexOf('?') == -1 ? document.querySelectorAll(".js-selected-filter-count").forEach((co)=>co.classList.add("hidden")): document.querySelectorAll(".js-selected-filter-count").forEach((co)=>co.classList.remove("hidden"));
    event.currentTarget.href.indexOf('?') == -1 ?  document.querySelector(".js-show-sort").querySelector("span").innerText = "Sort" : "";
    event.currentTarget.href.indexOf('?') == -1 ? document.querySelector("body").classList.remove("filter_active") : document.querySelector("body").classList.add("filter_active");
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
console.log("dfhjkghdfjkgh",FacetFiltersForm.hasActiveFilters())
// Initialize active_filter class on page load if filters are present
document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.getElementById('product-grid');
  const activeFilterButtons = document.querySelector('.active-facets-desktop').querySelectorAll("facet-remove");
  if (productGrid && FacetFiltersForm.hasActiveFilters() && activeFilterButtons.length > 1) {
    productGrid.classList.add('active_filter');
  }
  
  // Close filter drawer when clicking outside
  const filterDrawer = document.querySelector('.mobile-facets__wrapper');
  if (filterDrawer) {
    document.addEventListener('click', (event) => {
      const filterDetails = filterDrawer.querySelector('details.mobile-facets__disclosure');
      
      // Check if the drawer is open
      if (filterDetails && filterDetails.open) {
        const filterContent = filterDrawer.querySelector('.mobile-facets');
        const filterSummary = filterDrawer.querySelector('summary.mobile-facets__open-wrapper');
        
        // Check if click is outside the filter content and summary button
        if (filterContent && filterSummary && 
            !filterContent.contains(event.target) && 
            !filterSummary.contains(event.target)) {
          // Close the drawer by clicking the summary
          filterSummary.click();
        }
      }
    });
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);